<template>
  <div class="st-button-menu-mobile">
    <svg :class="{open: open}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 35 35" enable-background="new 0 0 35 35" xml:space="preserve">
      <circle :fill="colorTheme === 'dark' ? '#FFFFFF' : '#333333'" opacity="0.5" cx="18.2" cy="17.6" r="15.5"></circle>
      <line :stroke="colorTheme === 'dark'? '#333333' : '#FFFFFF'" v-bind="line" v-for="(line, i) in lines" :key="i"></line>
    </svg>
  </div>
</template>

<script>
import TweenLite from 'gsap/TweenLite'

export default {
  props: ['colorTheme', 'open'],
  data () {
    return {
      t: 0,
      lineStates: [
        {
          before: {x1: 10.5, y1: 13.2, x2: 26.1, y2: 13.2},
          after: {x1: 12.8, y1: 12.2, x2: 23.5, y2: 22.8}
        },
        {
          before: {x1: 10.5, y1: 17.6, x2: 26.1, y2: 17.6, opacity: 1},
          after: {x1: 10.5, y1: 17.6, x2: 0, y2: 17.6, opacity: 0}
        },
        {
          after: {x1: 12.8, y1: 22.8, x2: 23.5, y2: 12.2},
          before: {x1: 10.5, y1: 21.9, x2: 26.1, y2: 21.9}
        }
      ],
      lineProp: {
        'stroke': '#FFFFFF',
        'stroke-width': '1.7',
        'stroke-miterlimit': '10',
        'fill': 'none'
      }
    }
  },
  computed: {
    interpolators () {
      return this.lineStates.map(({before, after}) => interpolate(before, after))
    },
    lines () {
      const {t} = this
      return this.interpolators.map((interpolator) => Object.assign(interpolator(t), this.lineProp))
    }
  },
  watch: {
    open () {
      TweenLite.to(this.$data, 0.5, {t: this.open ? 1 : 0})
    }
  }
}

function interpolate (before, after) {
  return t => {
    const interpolated = {}
    Object.keys(after).forEach(key => {
      interpolated[key] = (1 - t) * before[key] + t * after[key]
    })
    return interpolated
  }
}
</script>

<style lang="scss">
.st-button-menu-mobile {
  svg {
    display: block;
    width: 32px;
    height: 32px;

    &.open {
      // animated burger style when modal open
      line {
        stroke: $black;
      }

      circle {
        fill: #FFFFFF;
      }
    }

    line {
      transition: stroke 0.5s;
    }
  }
}
</style>
